import './styles.css';
import { startAnalytics } from './analytics';
import { CONSENT_STORAGE_KEY, clearConsent, readConsent, saveConsent, type ConsentChoice } from './consent';
import { createPrivacyController } from './privacy';
import { getRuntime } from './runtime-config';

const banner = document.querySelector<HTMLElement>('[data-consent-banner]');
const dialog = document.querySelector<HTMLDialogElement>('[data-privacy-dialog]');
const firstPrivacyTrigger = document.querySelector<HTMLElement>('[data-open-privacy]');
if (!banner || !dialog || !firstPrivacyTrigger) throw new Error('Controles de privacidade ausentes.');

const consentBanner = banner;
const privacyDialog = dialog;

const privacy = createPrivacyController({ banner: consentBanner, dialog: privacyDialog, trigger: firstPrivacyTrigger });
const storage = (() => { try { return window.localStorage; } catch { return null; } })();
const runtime = getRuntime();
let consent = readConsent(storage);
const analytics = startAnalytics(runtime, consent?.choice ?? null);

function renderBanner(): void { consentBanner.hidden = Boolean(consent); }
function choose(choice: ConsentChoice): void {
  consent = saveConsent(storage, choice);
  const reload = analytics.update(choice);
  if (reload) { window.location.reload(); return; }
  renderBanner();
  if (privacyDialog.open) privacy.close();
}

document.querySelectorAll<HTMLElement>('[data-consent-accept]').forEach((button) => button.addEventListener('click', () => choose('accepted')));
document.querySelectorAll<HTMLElement>('[data-consent-reject]').forEach((button) => button.addEventListener('click', () => choose('rejected')));
document.querySelectorAll<HTMLElement>('[data-open-privacy]').forEach((button) => button.addEventListener('click', () => privacy.open(button)));
document.querySelector<HTMLElement>('[data-close-privacy]')?.addEventListener('click', privacy.close);
document.querySelector<HTMLElement>('[data-consent-clear]')?.addEventListener('click', () => {
  clearConsent(storage); consent = null;
  const reload = analytics.clear();
  if (reload) { window.location.reload(); return; }
  renderBanner(); privacy.close();
});
window.addEventListener('storage', (event) => {
  if (event.key !== CONSENT_STORAGE_KEY && event.key !== null) return;
  consent = readConsent(storage);
  const reload = consent ? analytics.update(consent.choice) : analytics.clear();
  if (reload) { window.location.reload(); return; }
  renderBanner();
});
renderBanner();
